import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { useTranslation } from 'react-i18next'
import type { PlaylistVisibilityEnum } from '~/__generated__/graphql'

type PlayListVisibilityRadioGroupProps = {
  value: PlaylistVisibilityEnum
  onChange: (value: PlaylistVisibilityEnum) => void
}

export const PlayListVisibilityRadioGroup = ({
  value,
  onChange,
}: PlayListVisibilityRadioGroupProps) => {
  const { t } = useTranslation()

  return (
    <RadioGroup
      row
      value={value}
      onChange={(e) => onChange(e.target.value as PlaylistVisibilityEnum)}
      sx={{ gap: 4, justifyContent: 'flex-start' }}
    >
      <FormControlLabel
        value='is_public'
        control={<Radio color='primary' />}
        label={t('playlist_visibility_public')}
        sx={{ color: '#ffffff' }}
      />
      <FormControlLabel
        value='is_private'
        control={<Radio color='primary' />}
        label={t('playlist_visibility_private')}
        sx={{ color: '#ffffff' }}
      />
    </RadioGroup>
  )
}
